import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopZomato = dynamic(() => import("../../components/software-partners/zomato/DesktopZomato"), {
    loading: () => <Loading />,
}
);

const MobileZomato = dynamic(() => import("../../components/software-partners/zomato/MobileZomato"), {
    loading: () => <Loading />,
}
);

const zomatoIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Zomato Orders Integrated with QueueBuster POS Software</title>
                <meta name="description" content="Manage Zomato orders seamlessly! Integrate QueueBuster POS for a unified experience." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/zomato" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/zomato" hrefLang="en-us" />
                <meta property="og:title" content="Zomato Orders Integrated with QueueBuster POS Software" />
                <meta property="og:description" content="Manage Zomato orders seamlessly! Integrate QueueBuster POS for a unified experience." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/zomato.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/zomato" />
            </Head>
            {mobileView ? <MobileZomato /> : <DesktopZomato />}
        </>
    )
}

export default zomatoIntegration